import React, { useState } from 'react'
import View from './../../Edit/EditCityDetails/View'
import { createCity as createCityGraphQL } from './../../../../../../Module/graphQL'
import { authorization } from './../../../../../../Module/Auth/Auth'
import { validateCityDataPayload } from '../../util/validators'

const AddCityDetailsController = props => {
  var [isSaving, setIsSaving] = useState(false)
  const createCity = async data => {
    if (!validateCityDataPayload(data)) {
      return
    }

    setIsSaving(true)
    data = {
      ...data,
      location: data.cityLocation,
    }
    delete data.cityLocation
    var response = await createCityGraphQL(authorization.getAPIKey(), data)
    var result = await response.json()
    if (result['errorMessage']) return alert(result['errorMessage'])
    if (result.errors && result.errors[0])
      return alert(new Error(result.errors[0].message))
    setIsSaving(false)

    props.history.push(
      `/dashboard/cities/${result.data.createCity.city.id}/edit`,
    )
  }

  return (
    <View
      isSaving={isSaving}
      updateCity={createCity}
      isLoaded={true}
      enableEditCountry={true}
      enableChangeTimezone={true}
      // Defaults
      surgeInterval={15}
      newcomersMissionsLimit={3}
      status="ACTIVE"
      morningCheckInTimeBefore={30}
      morningCheckInTimeAfter={30}
      lunchCheckInTime="07:30:00"
      lunchCheckInTimeBefore={30}
      lunchCheckInTimeAfter={30}
      afternoonCheckInTime="15:00:00"
      afternoonCheckInTimeBefore={30}
      afternoonCheckInTimeAfter={30}
      {...props}
    />
  )
}

export default AddCityDetailsController



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityAddEdit/Add/AddCityDetails/Controller.js